import { IFormViewForm } from 'components/FormView';

const CreditNotesForm: IFormViewForm = {
  id: 'CreditNotesForm',
  layout: {
    rows: 1,
    columns: 2
  },
  fields: [
    {
      id: 1,
      position: {
        row: 1,
        col: 1,
        colspan: 1.5
      },
      type: 'PAPER_CONTAINER',
      visible: true,
      props: {
        label: '',
        fullWidth: true
      },
      children: [
        {
          id: 6,
          type: 'TEXT_AREA',
          props: {
            label: 'General notes',
            name: 'GeneralNotes',
            size: 'large',
            style: {
              height: '300px',
            }
          }
        }
      ]
    },
    {
      id: 1,
      position: {
        row: 1,
        col: 2,
        colspan: 1.5
      },
      type: 'PAPER_CONTAINER',
      visible: true,
      props: {
        fullWidth: true
      },
      children: [
        {
          id: 6,
          type: 'TEXT_AREA',
          props: {
            label: 'Internal notes',
            name: 'InternalNotes',
            size: 'large',
            style: {
              height: '300px',
            }
          }
        }
      ]
    },
  ]
};

export default CreditNotesForm;
